module.exports = __webpack_public_path__ + "static/media/prev-tut.3959e063.svg";